<template>
    <div class="card" >
                            <h4 class="card-title  flexbox justify-content-between">
                                <strong>ADD NEW TRAINING</strong>
                                <div>
                                    <button class=" btn btn-sm btn-bold btn-primary" disabled v-if="loadTraining">
                                        <circle-spin class="m-0"></circle-spin>
                                    </button>
                                    <button class="btn btn-sm btn-bold btn-primary" :disabled="$v.$invalid" v-else @click="addTraining" type="button">Add Training</button>
                                </div>
                            </h4>
                            <div class="card-body">
                                <!-- <input type="file" accept=".xls,.xlsx"  ref="training" class="mb-10 form-control" @change="docSelected" placeholder="Choose..."/> -->
                                <div class="form-group">
                                    <label>Training Title</label>
                                    <input class="form-control" type="text" id="title" v-model="title" @blur="$v.title.$touch()"/>
                                    <div v-if="$v.title.$dirty">
                                        <div class="custom-error" v-if="!$v.title.required">*A title is required.</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-7">
                                        <div class="form-group">
                                        <label for="sub_topic">Sub Topic</label>
                                        <input class="form-control" type="text" id="sub_topic" v-model="sub_topic"/>
                                        <div v-if="error">
                                            <div class="custom-error">*A topic is required.</div>
                                        </div>
                                    </div>
                                        <div class="form-group">
                                            <label for="sub_content">Description</label>
                                            <textarea cols="30" rows="10" class="form-control" style="resize: none" id="sub_content" v-model="sub_content"></textarea>
                                            <div v-if="error">
                                                <div class="custom-error">*Content is required.</div>
                                            </div>
                                        </div>
                                        <button class="mb-10 btn btn-sm btn-bold btn-primary" @click="addContent" type="button">Add</button>        
                                    </div>
                                    <div class="col-md-5">
                                        <h6 class="fw-600">Sub Topics</h6>
                                        <div v-if="isContent" class="p-10 b-1 border-secondary">
                                            <div  class="mb-10 flex justify-content-between" v-for="(topic, i) in sub_topics" :key="i">
                                                <p>
                                                {{i+1}}). {{topic}}
                                                </p>
                                            </div>
                                        </div>
                                        <div v-else class="b-1 border-secondary text-center">No Content Yet</div>
                                    </div>
                                    <div v-if="content_error">
                                        You have to add content.
                                    </div>
                                </div>
                                
                            </div>
                        
                        </div>
</template>

<script>
import axios from "axios";
import {
  required
} from "vuelidate/lib/validators";

export default {
    data() {
        return {
            loadTraining: false,
            training: '',
            title: "",
            sub_topic: "",
            sub_content: "",
            sub_topics: [],
            sub_contents: [],
            isContent: false,
            content_error: false,
            columns: ["id", "title", "actions"],
            data: [],
            options: {
                headings: {
                id: "S/N",
                title: "Title",
                actions: "Actions"
                },
                sortable: ["title"],
                filterable: ["title"]
            },
            error: false,
        }
    },
    validations: {
        title: {required}
    },
    methods: {
        addContent() {
            if (this.sub_topic == '' || this.sub_content == '') {
                this.error = true
            }
            else {
                this.content_error = false
                
                this.sub_topics.push(this.sub_topic)
                this.sub_contents.push(this.sub_content)
                // console.log(this.sub_contents)
                this.isContent = true
                this.sub_topic = ""
                this.sub_content = ""
            }
        },
        addTraining(){
            if(this.sub_topics.length < 1){
                this.content_error = true
            }
            else{
                this.content_error = false
                let userData = {
                    title: this.title,
                    sub_topics: this.sub_topics,
                    sub_content: this.sub_contents.join(' ||| ')
                }
                this.loadTraining = true 
                // axios.post('/admin/add?type=training', formData)
                axios.post("/admin/add?type=training", userData)
                .then(res => {
                        this.loadTraining = false;
                        this.$notify({
                            group: 'response',
                            type: 'success',
                            title: 'Successfully added new training',
                            duration: 2500,
                            ignoreDuplicates: true
                        });
                        setTimeout(() => {
                            location.reload()
                        }, 3000)
                })
                .catch(err => {
                        this.loadTraining = false;
                        this.$notify({
                            group: 'response',
                            type: 'error',
                            title: `${err.response.data.message}`,
                            duration: 5000
                        });
                })
            }        
        }
    }
}
</script>